import NewsSectionComponent from './NewsSectionComponent';

const PresskitNewsSection = ({ slice }) => (
  <NewsSectionComponent slice={slice} />
);

export default PresskitNewsSection;
